// Seal Subscriptions Control
// Removes subscription widgets from quick-add forms on collection/homepage
// Keeps them visible on actual product pages

document.addEventListener('DOMContentLoaded', function() {
  // Only run on non-product pages
  if (!document.body.classList.contains('template-product')) {
    
    function removeSealWidgets() {
      // Remove subscription widgets from quick-add forms
      const quickAddForms = document.querySelectorAll('[id^="quick-add-"]');
      quickAddForms.forEach(function(form) {
        const sealElements = form.querySelectorAll('.sealsubs-target-element, .sealsubs-container, .sls-homepage-automatic, .sealsubs-full');
        sealElements.forEach(function(element) {
          element.remove();
        });
      });
    }
    
    // Run immediately
    removeSealWidgets();
    
    // Also run after any dynamic content loads
    setTimeout(removeSealWidgets, 1000);
    
    // Watch for dynamically added content
    if (window.MutationObserver) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            removeSealWidgets();
          }
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
});
